import { __decorate } from "tslib";
import Avatar from '@/components/Avatar.vue';
import { Component, Emit, Prop, Vue } from "vue-property-decorator";
let CustomerSearchResults = class CustomerSearchResults extends Vue {
    isDataLoading;
    shown;
    value;
    customers;
    currentFocus;
    emitValue(customer) {
        return { customerId: customer._id };
    }
};
__decorate([
    Prop({ type: Boolean })
], CustomerSearchResults.prototype, "isDataLoading", void 0);
__decorate([
    Prop({ type: Boolean })
], CustomerSearchResults.prototype, "shown", void 0);
__decorate([
    Prop({ type: Object })
], CustomerSearchResults.prototype, "value", void 0);
__decorate([
    Prop({ type: Array })
], CustomerSearchResults.prototype, "customers", void 0);
__decorate([
    Prop({ type: Number })
], CustomerSearchResults.prototype, "currentFocus", void 0);
__decorate([
    Emit("input")
], CustomerSearchResults.prototype, "emitValue", null);
CustomerSearchResults = __decorate([
    Component({
        name: 'CustomerSearchResults',
        components: {
            Avatar,
        },
    })
], CustomerSearchResults);
export default CustomerSearchResults;
